// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modify-order-no .el-form-item .el-form-item__label {\n  width: 80px;\n}\n.modify-order-no .el-form-item .el-form-item__content {\n  width: calc( 100% - 100px);\n  float: left;\n}\n.modify-order-no .el-form-item .el-form-item__content .el-select {\n    width: 100%;\n}\n", ""]);
// Exports
module.exports = exports;
